import { Button, Divider, Skeleton, Space, Tag, Timeline, List, Card, Alert, Collapse } from 'antd';
import gql from 'graphql-tag';
import Markdown from 'react-markdown';
import { useAuthedQuery } from 'utils/qlAuth';
import React from 'react';
import {
  FrameImportController_importAudioFromFolder,
  FrameImportController_importFramesFromFolder,
  FrameImportController_importFramesFromLeonardo,
  StoryController_createFrames,
  StoryController_removeFrames,
} from './buttons';
import { StopOutlined } from '@ant-design/icons';
import { StoryFramesModel } from 'interface/models';
import { BottomButtons } from 'components/SharedComponents/BottomButtons/BottomButtons';

const TtsTextElement = (props: { tts: string }) => {
  if (!props.tts) {
    return <StopOutlined />;
  }

  // const ttsText = String(props.tts).replaceAll(/"+/gm, '').split(`:`);

  return <>{props.tts}</>;
};

export const StoryFrames = (props: { qStory: any; storyId: number }) => {
  const qFrames = useAuthedQuery(
    gql`
      query FrameController_getStoryFrames($storyId: Int!) {
        FrameController_getStoryFrames(storyId: $storyId) {
          id
          frameIndex
          promt
          tts
          status
        }
      }
    `,
    {
      variables: { storyId: Number(props.storyId) },
    },
  );

  const [showType, setShowType] = React.useState('tts');

  if (qFrames.error) {
    return <div>error</div>;
  }
  if (qFrames.loading) {
    return <Skeleton active />;
  }

  const story = props.qStory.data?.StoryController_getStoryById || {};
  const frames = qFrames.data?.FrameController_getStoryFrames || [];

  return (
    <>
      <Space direction="vertical" style={{ width: '100%' }}>
        <Alert
          type="info"
          message="Import audio from folder and create frames for it based on text transcription"
          action={<FrameImportController_importAudioFromFolder qStory={props.qStory} storyId={Number(props.storyId)} />}
          style={{ width: '100%' }}
          showIcon
        />
        <Alert
          type="info"
          message="Import images from folder"
          action={<FrameImportController_importFramesFromFolder qStory={props.qStory} storyId={Number(props.storyId)} />}
          style={{ width: '100%' }}
          showIcon
        />
        <Alert
          type="info"
          message={`Create frames for the story (Method ${story.type})`}
          action={<StoryController_createFrames qStory={props.qStory} storyId={Number(props.storyId)} />}
          style={{ width: '100%' }}
          showIcon
        />
        <Collapse defaultActiveKey={[]}>
          <Collapse.Panel header="Deprecated functions" key="1">
            <Alert
              type="info"
              message="Import frame descriptions from Leonardo (based on imported files)"
              action={<FrameImportController_importFramesFromLeonardo qStory={props.qStory} storyId={Number(props.storyId)} />}
              style={{ width: '100%' }}
              showIcon
            />
          </Collapse.Panel>
        </Collapse>
      </Space>

      <BottomButtons extra={<StoryController_removeFrames qStory={props.qStory} storyId={Number(props.storyId)} />}>
        <Button
          size="small"
          onClick={() => {
            setShowType('full');
          }}
          type={showType === 'full' ? 'primary' : 'default'}
        >
          Full
        </Button>
        <Button
          size="small"
          onClick={() => {
            setShowType('tts');
          }}
          type={showType === 'tts' ? 'primary' : 'default'}
        >
          TTS
        </Button>
        <Button
          size="small"
          onClick={() => {
            setShowType('promts');
          }}
          type={showType === 'promts' ? 'primary' : 'default'}
        >
          Promts
        </Button>
      </BottomButtons>
      <Divider />
      {frames.length > 0 && (
        <Timeline
          items={(frames || [])
            // .filter(item => !item.tts)
            .map((item: StoryFramesModel, index: number) => {
              let ui = (
                <>
                  <TtsTextElement tts={item.tts} />
                  <Divider />
                  <Markdown>{item.promt}</Markdown>
                </>
              );

              if (showType === 'tts') {
                ui = <TtsTextElement tts={item.tts} />;
              }
              if (showType === 'promts') {
                ui = <Markdown>{item.promt}</Markdown>;
              }

              return {
                key: index,
                children: ui,
                color: `blue`,
                dot: showType === 'tts' ? null : <div>{index}</div>,
              };
            })}
        />
      )}
    </>
  );
};
